import { cloneDeep } from 'lodash';
import { Program } from '../interfaces';
import { toMoment } from './huaweiUtils';

export function convertProgramDates(program: Program): Program {
  if (program?.starttime === undefined || program?.endtime === undefined) {
    return program;
  }

  return {
    ...program,
    starttime: toMoment(program.starttime).format(),
    endtime: toMoment(program.endtime).format(),
  };
}

export function convertRecordingDates<T>(recording: T): T {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const copy = cloneDeep(recording) as any;
  const isUTC = true;

  if ('beginTime' in copy && copy.beginTime) {
    copy.beginTime = toMoment(copy.beginTime, isUTC).format();
  }

  if ('endTime' in copy && copy.endTime) {
    copy.endTime = toMoment(copy.endTime, isUTC).format();
  }

  if ('effectivetime' in copy && copy.effectivetime) {
    copy.effectivetime = toMoment(copy.effectivetime, isUTC).format();
  }

  if ('createTime' in copy && copy.createTime) {
    copy.createTime = toMoment(copy.createTime, isUTC).format();
  }

  if ('updateTime' in copy && copy.updateTime) {
    copy.updateTime = toMoment(copy.updateTime, isUTC).format();
  }

  if ('fromToToday' in copy && copy.fromToToday) {
    copy.fromToToday = toMoment(copy.fromToToday, isUTC).format();
  }

  if ('latestPVRTask' in copy && copy.latestPVRTask) {
    copy.latestPVRTask = convertRecordingDates(copy.latestPVRTask);
  }

  if ('pvrList' in copy && copy.pvrList) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    copy.pvrList = copy.pvrList.map((pvr: any) => convertRecordingDates(pvr));
  }

  return copy;
}
